import PropTypes from 'prop-types';

import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import * as Styled from '../ReportSection.style';

/**
 * Wrapper component that handles icon placement based on screen size
 * Renders icon in appropriate position for desktop vs mobile layouts
 *
 * @param {object} props - Component props
 * @param {React.ReactElement} props.icon - Icon component to render
 * @param {string} props.placement - Where to render the icon: 'desktop' or 'mobile'
 */
function SectionIconWrapper({ icon, placement }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Desktop placement: show only on desktop
  if (placement === 'desktop' && !isMobile && icon) {
    return <Styled.SectionIcon>{icon}</Styled.SectionIcon>;
  }

  // Mobile placement: show only on mobile
  if (placement === 'mobile' && isMobile && icon) {
    return <Styled.SectionIcon>{icon}</Styled.SectionIcon>;
  }

  return null;
}

SectionIconWrapper.propTypes = {
  icon: PropTypes.element,
  placement: PropTypes.oneOf(['desktop', 'mobile']).isRequired
};

export default SectionIconWrapper;
